import { ComponentProps } from 'react';
import { Typography } from '../../../atoms/typography/typography';
import { twMerge } from 'tailwind-merge';

type TextProps = {
  text: string | number;
  weight?: 'regular' | 'medium';
  variant?: ComponentProps<typeof Typography>['variant'];
  className?: string;
};

export function Text(props: TextProps) {
  const { text, weight = 'regular', variant = 'body-xs', className } = props;
  return (
    <Typography
      variant={variant}
      weight={weight}
      className={twMerge('text-grayscale600', className)}
    >
      {text}
    </Typography>
  );
}
